// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1u14T","loginBlock":"Header_loginBlock__1kPPY"};